/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rightWhite': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M37.636 23.417L16.612 2.362c-1.223-1.15-3.096-1.15-4.248 0-1.152 1.15-1.152 3.09 0 4.24L31.3 25.5 12.364 44.399c-1.152 1.22-1.152 3.09 0 4.239 1.152 1.15 3.025 1.15 4.248 0l21.024-20.982c1.152-1.22 1.152-3.09 0-4.24z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
